<ng-container
  [dynamicWidget]="input.contentWidget"
  [context]="context"
></ng-container>
